import React from 'react';
import { PromoStrip } from '../../components/PromoStrip/PromoStrip';
import styled from '@emotion/styled';
import RichText from '../../util/RichText';
import getBackgroundColor from '../../util/getBackgroundColor';

const PromoStripWrapperContainer = styled.div`
  display: flex;
  min-height: 6rem;
  .promo-strip {
    align-items: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 100%;
    background-color: ${({ bgColor }) => bgColor};
  }
  .promo-strip-content-container {
    align-items: center;
    display: flex;
    justify-content: center;
    padding: 30px;
    font-size: 1.5em;
    line-height: 2em;
    color: ${({ fontColor }) => fontColor};
  }
`;

const PromoStripWrapper = ({ fields }) => {
  const bgColor = getBackgroundColor(fields?.backgroundColor);
  const content = RichText(fields?.blocks[0].fields?.content);
  const mobContent = RichText(fields?.blocks[0].fields?.mobileContent);

  return (
    <PromoStripWrapperContainer
      data-testid="promo-strip-wrapper"
      bgColor={bgColor}
      fontColor={fields?.fontColor || '#000'}
    >
      <PromoStrip content={content} mobContent={mobContent} />
    </PromoStripWrapperContainer>
  );
};

export { PromoStripWrapper };
